import DropSelect from 'sma.admin/components/dropdowns/dropselect';
import DropSelectEditable from 'sma.admin/components/dropdowns/dropselecteditable';
import DropSelectExtendable from 'sma.admin/components/dropdowns/dropselectextendable';
import Dropdown from 'sma.admin/components/dropdowns/dropdown';
import { Confirm } from 'sma.common/components/modals';
import Alert from 'sma.admin/components/alert';
import Loader from 'sma.admin/components/loader';
import { randomString } from 'sma.common/utils';

const ajax = require('sma.common/ajax');

const emptyTempl = require('sma.admin/components/partials/grids/empty.mustache');
const checkboxTemplate = require('sma.admin/components/partials/checkbox.mustache');
const nestedRowTempl = require('sma.admin/components/partials/grids/nested_row.mustache');
const rowsPerPageSelector = require('sma.admin/components/partials/grids/rows_per_page_selector.mustache');

let Grid = Backbone.View.extend({
	columns: [],
	visibleColumns: [],
	showSelectLabel: true,
	filters: [],
	gridLabel: '',
	nothingSelectedErrorMessage: '',

	actions: [],
	extraToolbarItems(grid) { return []; },
	noDataMessage: gettext('There is no data to display'),

	showSelectorColumn: true,
	rowClass: '',

	loading: false,
	loadingUid: null,

	page: 1,
	perPage: 25,
	perPageAmounts: [25, 50, 100, 250],
	showPagination: true,
	total: 0,
	orderedBy: '',
	orderDir: 'asc',

	base_query: 'active', // Base query_set of data to return (active, inactive, archived)
	grid_id: undefined, // To pass in URL if necessary

	selected: {},
	searchterm: '',
	expandableCols: [],
	container: null,

	title: '',
	caption: '',
	showToolbar: true,
	showTitlebar: true,
	showFooter: true,
	showColumnDropSelect: true,
	showSearchBar: true,
	showExtraToggle: false,
	selectedRows: [],
	extraData: {}, // Passed on all ajax requests

	loaderSize: 'sm',
	sortCacheKey: '',

	tallyExtraLabel: false, // Show string "x of y selected" next to selected count

	cls: 'sma-grid',

	folderGrid: false,
	intID: true,
	multiPageSelect: false,

	events: {
		'change tbody td[role="select"] input[type="checkbox"]': 'rowSelectionChanged',
		'change tbody td[class="js-grid-row-select"] input[type="checkbox"]': 'rowSelectionChanged',

		'click .pager-previous': 'loadPrev',
		'click .pager-next': 'loadNext',
		'click .grid-column-name': 'orderingSelectionChanged',
		'click .js-grid-search-btn': 'search',
		'click .sma-js-nested-table': 'expandNestedTable',
		'click .sma-js-nested-content': 'expandNestedContent',
		'click tbody > tr': 'rowClicked',
		'click .sma-js-select-all': 'selectAll',
		'change .sma-js-rows-per-page-selector': 'changedRowsPerPage',

		'click .sma-js-triggers-folder-cell': 'expandFolderContent',
		'click .sma-js-funds-folder-cell': 'expandFolderContent',

		'keyup .sma-grid-search': 'searchKeyup',
	},

	initialize(config) {
		this.showSelectLabel = config.showSelectLabel === undefined ? this.showSelectLabel : config.showSelectLabel;
		this.url = config.url;
		this.columnsUrl = config.columnsUrl || '';

		this.extraToolbarItems = config.extraToolbarItems || this.extraToolbarItems;
		this.onLoad = this.onLoad || config.onLoad;
		if (this.selectedIds === undefined) {
			this.selectedIds = []
		}
		if (config.extraData !== undefined) {
			this.extraData = config.extraData;
		}

		if (config.showSelectorColumn !== undefined) {
			this.showSelectorColumn = config.showSelectorColumn;
		}

		if (config.container !== undefined) {
			this.container = config.container;
		}

		if (config.columns !== undefined) {
			this.columns = config.columns;
		}

		if (config.hasOwnProperty('showToolbar')) {
			this.showToolbar = config.showToolbar;
		}

		if (config.showFooter !== undefined) {
			this.showFooter = config.showFooter;
		}

		if (config.showTitlebar !== undefined) {
			this.showTitlebar = config.showTitlebar;
		}

		if (config.showSearchBar !== undefined) {
			this.showSearchBar = config.showSearchBar;
		}

		if (config.showColumnDropSelect !== undefined) {
			this.showColumnDropSelect = config.showColumnDropSelect;
		}

		if (config.award_id !== undefined) {
			this.award_id = config.award_id;
		}

		if (config.workflow_id !== undefined) {
			this.workflow_id = config.workflow_id;
		}

		if (config.grid_id !== undefined) {
			this.grid_id = config.grid_id;
		}

		if (config.title !== undefined) {
			this.title = config.title;
		}

		if (config.caption !== undefined) {
			this.caption = config.caption;
		}

		if (config.results !== undefined) {
			this.results = config.results;
		}

		if (config.actions !== undefined) {
			this.actions = config.actions;
		}

		this.hiddenColumns = [];

		if (config.hiddenColumns !== undefined) {
			this.hiddenColumns = config.hiddenColumns;
		}

		if (config.resultsKey !== undefined) {
			this.resultsKey = config.resultsKey;
		}

		if (config.sortCacheKey !== undefined) {
			this.sortCacheKey = config.sortCacheKey;
		}

		if (config.updateTallyCallback !== undefined) {
			this.updateTallyCallback = config.updateTallyCallback;
		}

		this.preRenderInit(config);

		if (config.intID !== undefined) {
			this.intID = config.intID;
		}

		this.setElement(config.element[0]);
		this.element = config.element;

		if (config.kwargs !== undefined) {
			this.kwargs = config.kwargs;
		}

		this.acceptType == 'json';
		if (config.acceptType !== undefined) {
			this.acceptType == config.acceptType;
		};

		this.actionDropdown = null;

		this.render();
		this.postInit(config);
		this.results = undefined;
		if (typeof config.multiPageSelect !== 'undefined') {
			this.multiPageSelect = config.multiPageSelect;
		}
	},

	preRenderInit(config) { },

	postInit(config) { },

	hideColumn(column_id) {
		if (this.hiddenColumns.indexOf(column_id) < 0) {
			this.hiddenColumns.push(column_id);
		}

		let columnInfo = null;
		for (let column of this.columns) {
			if (column.id == column_id) {
				columnInfo = column;
				break;
			}
		}

		if (columnInfo == null) return;

		let index = this.visibleColumns.indexOf(columnInfo);
		if (index > -1) {
			this.visibleColumns.splice(index, 1);
		}
	},

	showColumn(column_id) {
		let index = this.hiddenColumns.indexOf(column_id);
		if (index > -1) {
			this.hiddenColumns.splice(index, 1);
		}

		let columnInfo = null;
		for (let column of this.columns) {
			if (column.id == column_id) {
				columnInfo = column;
				break;
			}
		}

		if (columnInfo == null) return;

		if (this.visibleColumns.indexOf(columnInfo) === -1) {
			this.visibleColumns.push(columnInfo);
		}
	},

	nothingSelected() {
		this.alertMessage(
			'danger',
			this.nothingSelectedErrorMessage
		);
	},

	alertMessage(type, msg) {
		new Alert({
			type: type,
			message: msg,
		});
	},

	setExtraColumns() {
		this.extraColumns = [];
		return [];
	},

	initializeFilters() {

	},

	buildVisibleColumns(columnList) {
		if (columnList === undefined) {
			columnList = [];
			for (let c of [...this.columns, ...this.extraColumns]) {
				columnList.push(c.id);
			}
		}

		this.visibleColumns = [];
		for (let column of [...this.columns, ...this.extraColumns]) {
			if (columnList.indexOf(column.id) > -1 && this.hiddenColumns.indexOf(column.id) == -1) {
				this.visibleColumns.push(column);
			}
		}
	},

	render() {
		this.$el.empty();

		this.wraps = $('<div></div>'); //$('<div class="table-responsive"></div>');
		this.tableWrapperRow = $('<div></div>', { 'class': 'sma-table-wrapper' });
		this.tableWrapperCol = $('<div></div>', { 'class': 'sma-js-table-left' });

		this.table = $('<table></table>', { 'class': 'table table-hover' });
		if (this.kwargs && this.kwargs.tableClass) {
			this.table.addClass(this.kwargs.tableClass);
		}
		this.caption = $(`<caption>${this.caption}</caption>`);
		this.head = $('<thead></thead>');
		this.body = $('<tbody></tbody>');
		this.footer = $('<div class="grid-footer"></div>');

		this.tableWrapperCol.append(this.table);
		this.tableWrapperRow.append(this.tableWrapperCol);

		this.table.append(this.caption, this.head, this.body);
		this.wraps.append(this.tableWrapperRow);

		if (this.showFooter) {
			this.table.after(this.footer);
		}

		this.$el.append(this.wraps);
		this.$el.addClass(this.cls);

		this.loader = new Loader(this.tableWrapperRow, this.loaderSize);
		this.loader.hide();

		let defaultColumns = [];

		this.extraColumnContainers = this.setExtraColumns();


		if (this.columnsUrl) {
			let options = {
				url: this.columnsUrl,
				callback: (response) => {
					this.visibleColumns = [];
					this.buildVisibleColumns(response.columns);

					this.extraColumnContainers = this.setExtraColumns();
					this.reOrderColumns();
					this.renderColumnHeaders();
					this.renderHeaders();

					this.cachedSort();
					if (this.orderedBy && this.orderDir) {
						this.updateSortColumn(this.orderedBy, this.orderDir);
					}

					this.load();
				},
			};

			ajax.get(options);
			return;
		}

		this.columns.forEach((column) => {
			let isDefault = column.isDefault !== undefined ? column.isDefault : true;
			if (isDefault) {
				defaultColumns.push(column);
			}
		});
		this.visibleColumns = defaultColumns;
		this.reOrderColumns();
		this.renderHeaders();

		this.cachedSort();
		if (this.orderedBy && this.orderDir) {
			this.updateSortColumn(this.orderedBy, this.orderDir);
		}

		this.load();
	},

	renderSearchBar() {
		let searchInput = $('<div></div>', { 'class': 'input-group sma-grid-search' });

		this.searchBox = $('<input>', {
			type: 'text',
			'class': 'form-control',
			placeholder: gettext('Search...'),
		});

		searchInput.append(this.searchBox);

		searchInput.append(
			$('<span></span>', { 'class': 'input-group-btn' })
				.append(
					$('<button></button>', {
						'class': 'btn btn-default btn-icononly js-grid-search-btn',
						type: 'button',
					})
						.append(
							$('<i class="nc-icon-mini ui-1_zoom"></i>'),
						),
				),
		);

		this.searchBox.val(this.searchterm);

		return searchInput;
	},

	renderExtraToggle() { },

	rowClicked(e) { },

	searchKeyup(e) {
		if (e.which == 13) {
			this.search();
		}
	},

	getColumnsForDropSelect() {
		return this.columns;
	},

	renderColumnDropdown() {
		this.checkableColumns = _.filter(this.getColumnsForDropSelect(), item => (!item.alwaysDisplayed && !item.hideFromDropdown));

		// Sort columns by index
		this.checkableColumns = this.checkableColumns.sort((a, b) => a.index - b.index);

		let columns = _.map(this.checkableColumns, (column) => {
			let visibleColumnIds = _.map(this.visibleColumns, column => column.id);

			return {
				name: column.id,
				text: column.name || 'blank',
				checked: visibleColumnIds.indexOf(column.id) > -1,
			};
		});

		let columnSelect = new DropSelectExtendable({
			title: '<i class="nc-icon-mini ui-2_menu-bold sma-rotate-90"></i>',
			items: columns,
			extraItems: this.extraColumnContainers,
			onDone: this.refreshColumns.bind(this),
		}).$el;

		return columnSelect;
	},

	getSelectedIds() {
		return this.selectedIds;
	},

	getSelectedRows() {
		return this.selectedRows;
	},

	getActionData() {
		return {
			grid: this,  // TODO: returning itself?? Look into and cleanup
			ids: this.getSelectedIds(),
			rows: this.getSelectedRows(),
		};
	},

	renderActionsDropdown() {
		let actionSelect = new Dropdown({
			title: gettext('Actions'),
			btnclass: 'btn-default',
			items: this.actions,
			addActionData: this.getActionData.bind(this),
		});

		actionSelect.$el.addClass('form-group btn-group');

		return actionSelect;
	},

	renderDropSelectEditable(options) {
		options.additionalScope = this;

		let select = new DropSelectEditable(options).$el;

		select.addClass('form-group btn-group sma-grid-toolbar-extra');

		return select;
	},

	renderDropdown(dropdown) {
		let select = new Dropdown({
			title: dropdown.title,
			btnclass: 'btn-default',
			items: dropdown.actions,
			addActionData: this.getActionData.bind(this),
		}).$el;

		select.addClass('form-group btn-group sma-grid-toolbar-extra');

		return select;
	},

	renderDropselect(dropselect) {
		let select = new DropSelect({
			title: dropselect.title,
			items: dropselect.items,
			addActionData: this.getActionData.bind(this),
			onDone: dropselect.onDone.bind(this),
			onClick: dropselect.onClick.bind(this),
		}).$el;

		return select;
	},

	renderItem(item) {
		/* Renders a non-dropdown for toolbar */
		let el = $(item.html);
		let that = this;

		el.addClass('sma-grid-toolbar-extra');

		el.on(item.trigger, () => item.action(that.getActionData()));
		return el;
	},

	updateTallyCallback(grid) {

	},

	updateTally() {
		if (this.tally == undefined) return;

		this.tally.text(this.selectedIds.length);
		if (this.selectedIds.length === 0) {
			this.tally.addClass('zero');
			if (this.actionDropdown) {
				this.actionDropdown.disable();
			}
		} else {
			this.tally.removeClass('zero');
			if (this.actionDropdown) {
				this.actionDropdown.enable();
			}
		}

		this.updateTallyCallback(this);
	},

	renderTally() {
		this.clearSelections();
		this.tally = $('<div class="sma-grid-tally zero"></div>');
		this.tally.text(this.selectedIds.length);

		return this.tally;
	},

	renderTallyExtra() {
		if (this.tallyExtraLabel) {
			if (!this.tallyExtra) {
				this.tallyExtra = $('<div class="sma-grid-tally-extra mr-2"></div>');

				let total = this.total;

				this.tallyExtra.text(`/ ${total}`);
				this.tallyExtra.insertAfter(this.tally);
			} else {
				let total = this.total;

				this.tallyExtra.text(`/ ${total}`);
			}
		}
	},

	renderExtraToolbarItems(grid, left) {
		this.extraToolbarItems(this).forEach((item) => {
			switch (item.type) {
				case 'dropdown':
					left.append(grid.renderDropdown(item));
					break;
				case 'dropselect':
					left.append(grid.renderDropselect(item));
					break;
				case 'dropselecteditable':
					left.append(grid.renderDropSelectEditable(item));
					break;
				case 'custom':
					left.append(item.rendered);
					break;
				case 'custom_renderer':
					left.append(item.customRenderer(item));
					break;
				default:
					left.append(grid.renderItem(item));
			}
		});
	},

	renderToolbar() {
		if (!this.showToolbar) return;

		let toolbar = $('<div class="row sma-grid-toolbar"></div>');

		let left = $('<div class="form-inline"></div>');
		let right = $('<div></div>');

		if (this.showSelectorColumn === true) {
			left.append(this.renderTally());
			if (this.tallyExtra) {
				left.append(this.tallyExtra);
			}
		}

		if (this.actions.length > 0) {
			this.actionDropdown = this.renderActionsDropdown();
			left.append(this.actionDropdown.$el);
		}

		this.renderExtraToolbarItems(this, left);

		left.append(
			this.showExtraToggle ? this.renderExtraToggle() : null,
		);

		if (this.showSearchBar || this.showColumnDropSelect) {
			left.addClass('col-sm-7');
			right.addClass('col-sm-5');
			right.append(
				$('<div class="form-inline float-sm-right"></div>')
					.append(
						this.showSearchBar ? this.renderSearchBar() : null,
						this.showColumnDropSelect ? this.renderColumnDropdown() : null,
					),
			);
		} else {
			left.addClass('col-12');
			right.removeClass('col-sm-5');
		}

		toolbar.append(left, right);

		if (this.postRenderToolbar) {
			this.postRenderToolbar(left, right);
		}

		return toolbar;
	},

	renderTitle() {
		return $('<h5></h5>').append(this.title);
	},

	addToLeftTitlebar($left) {
		$left.append(this.renderTitle());
	},

	addToRightTitlebar($right) { },

	renderTitlebar() {
		let $titlebar = $('<div class="row sma-grid-titlebar"></div>');

		if (!this.showTitlebar) return;

		let $left = $('<div class="col-sm-6 sma-titlebar-left"></div>');

		let $rightInner = $('<div class="ml-auto"></div>');
		let $rightOuter = $('<div class="col-sm-6 sma-titlebar-right"></div>')
			.append(
				$('<div class="d-flex justify-content-start"></div>')
					.append($rightInner),
			);

		this.addToLeftTitlebar($left);
		this.addToRightTitlebar($rightInner);

		$titlebar.append($left, $rightOuter);

		return $titlebar;
	},

	renderColumnHeaders() {
		if (this.$columnHeaders !== undefined) {
			this.$columnHeaders.empty();
		} else {
			this.$columnHeaders = $('<tr></tr>');
		}

		if (this.showSelectorColumn === true) {
			this.$columnHeaders.append(
				$('<th></th>', {
					...(this.showSelectLabel ? { role: 'select' } : {}),
					...(!this.showSelectLabel ? { class: 'js-grid-header-select' } : {}),
					scope: 'col',
					html: checkboxTemplate(
						{
							class: 'sma-js-select-all',
							ariaLabel: "Select all tasks",
						},
					), // '<input type="checkbox">'
				}),
			);
		}

		this.visibleColumns.forEach((col) => {
			let className = '';

			if (col.sortable) {
				className = 'grid-column-name';
			}

			let header = $('<th></th>', {
				text: col.name,
				'data-column': col.id,
				scope: 'col',
				'class': className,
			});
			if (col.showLabel) {
				header.append($('<span></span>', { 'class': 'sr-only', text: col.showLabel }));
			}
			if (col.htmlHeader) {
				header.html(col.htmlHeader);
			}

			let htmlTooltip = col.htmlTooltip ? true : false;

			if (col.tooltip) {
				let tooltip = $(`<i data-toggle="tooltip" data-html="${htmlTooltip}" data-placement="bottom" class="mx-1 nc-icon-mini ui-e_round-e-info"></i>`);
				tooltip.attr('title', col.tooltip);

				header.append(tooltip);
				header.tooltip({
					selector: '[data-toggle=tooltip]',
					html: htmlTooltip,
				})
			}

			this.$columnHeaders.append(header);
		});
	},

	renderHeaders() {
		this.wraps.find('.sma-grid-toolbar, .sma-grid-titlebar, .sma-grid-filterbar-container').remove();
		this.wraps.prepend(this.renderToolbar());
		this.wraps.prepend(this.renderTitlebar());

		this.renderColumnHeaders();
		this.head.append(this.$columnHeaders);
		this.wraps.prepend($('<div class="sma-grid-filterbar-container"></div>'));
		if (this.gridFilter) {
			this.gridFilter.undelegateEvents();
		}
		this.initializeFilters();
	},

	renderFooter(data) {
		this.footer.empty();

		let row = $('<div class="sma-pager d-sm-flex justify-content-center align-items-center">');
		let tools = $('<div class="sma-pager-refresh"></div>');

		tools.append(
			$('<a></a>', {
				'href': '#',
				'class': 'sma-link-text',
				'html': '<i class="nc-icon-mini arrows-1_refresh-69"></i>',
				'click': () => this.load(),
			}),
		);

		if (this.showPagination) {
			let page = $('<div class="sma-pager-current"></div>');
			let pager = $('<div class="sma-pager-navigaton"></div>');
			let totals = $('<div class="sma-pager-applications"></div>');
			let rowsPerPage = $('<div class="sma-pager-rows-per-page"></div>');
			let pagerList = $('<ul class="pager"></ul>');

			let lbound = ((this.page - 1) * this.perPage);

			page.append($('<div></div>', {
				text: gettext('Page: ') + this.page,
			}));

			totals.append($('<div></div>', {
				text: '(' + (lbound + 1) + ' - ' + (lbound + data.results.length) + gettext(' of ') + this.total + ')'
			}));

			let items = [];

			this.perPageAmounts.forEach((amount) => {
				items.push({
					name: amount.toString(),
					value: amount,
					selected: amount === this.perPage,
				});
			});

			rowsPerPage.append($(rowsPerPageSelector({
				items: items,
			})));

			if (data.previous != null) {
				pagerList.append(
					$('<li></li>')
						.append(
							$('<a></a>', {
								href: data.previous,
								'class': 'btn btn-default pager-previous',
								text: gettext('Previous'),
							}),
						),
				);
			}

			if (data.next != null) {
				pagerList.append(
					$('<li></li>')
						.append(
							$('<a></a>', {
								href: data.next,
								'class': 'btn btn-default pager-next',
								text: gettext('Next'),
							}),
						),
				);
			}
			pager.append(pagerList);
			row.append(page, totals, rowsPerPage, pager, tools);
		}
		else {
			row.append(tools);
		}

		this.footer.append(row);
	},

	getColSorting() {
		if (this.orderDir == 'desc') {
			return '-' + this.orderedBy;
		}
		return this.orderedBy;
	},

	getParams() {
		let params = {
			page: this.page,
			per_page: this.perPage,
			ordering: this.getColSorting(),
			base_query: this.base_query,
			search: this.searchterm,
		};

		for (var key in this.extraData) {
			params[key] = this.extraData[key];
		}

		if (this.filters.length > 0) {
			params.filters = JSON.stringify(this.filters);
		}

		return params;
	},

	reOrderColumns() {
		// Sort columns by index
		this.visibleColumns = this.visibleColumns.sort((a, b) => (a.index - b.index));
	},

	refreshColumns(checkedItems) {
		this.visibleColumns = [];

		this.columns.concat(this.extraColumns).forEach((col) => {
			let isChecked = _.find(checkedItems, item => item.name === col.id && item.checked === true);

			if (isChecked !== undefined || col.alwaysDisplayed || col.hideFromDropdown) {
				this.visibleColumns.push(col);
			}
		});

		this.setVisibleColumns(this.visibleColumns);
	},

	setVisibleColumns(visibleColumns, asIds = false) {
		if (this.columnsUrl) {
			let columns = [];
			for (let col of visibleColumns) {
				if (asIds) {
					columns.push(col);
				} else {
					columns.push(col.id);
				}
			};

			const options = {
				url: this.columnsUrl,
				data: {
					columns,
				},
				alertOnSuccess: false,
				callback: (response) => {
					this.buildVisibleColumns(response.columns);
					this.reOrderColumns();
					this.renderColumnHeaders();
					this.load();
				},
			};
			ajax.post(options);
			return;
		}

		this.reOrderColumns();
		this.renderColumnHeaders();
		this.load();
	},

	load(callback) {
		const loadingUid = randomString(20);
		this.loadingUid = loadingUid;
		this.element.addClass('sma-grid-loading');

		this.loading = true;
		let that = this;

		this.body.empty();

		this.selectedRows = [];

		if (typeof this.data !== 'undefined') {
			this.selectedRows = _.filter(this.data.results, obj => {
				return typeof _.find(this.selectedIds, id => (obj.id === id)) !== 'undefined'
			});
		}

		this.table.hide();
		this.footer.hide();
		this.loader.show();

		const url = this.getUrl();

		if (this.results === undefined) {
			const ajaxOptions = {
				type: 'GET',
				url,
				data: this.getParams(),
				headers: {
					Accept: 'application/json',
				},
				success: $.proxy(
					function (response) {
						if (loadingUid === this.loadingUid) {
							this.loadResults(response);
							if (callback !== undefined) callback(this);
							if (this.onLoad !== undefined) {
								this.onLoad(this, response);
							}
							this.renderTallyExtra();
							this.table.trigger('smagrid:reloaded');
							this.changeSelectAll()
						}
					},
					this
				),
				error: $.proxy(
					function (jqXHR, textStatus, errorThrown) {
						if (jqXHR.status === 404) {
							if (this.page > 1) {
								this.loadPrev();
							} else {
								let response = { count: 0, results: [] };
								if (loadingUid === this.loadingUid) {
									this.loadResults(response);
									if (callback !== undefined) callback(this);
									if (this.onLoad !== undefined) {
										this.onLoad(this, response);
									}
									this.renderTallyExtra();
									this.table.trigger('smagrid:reloaded');
								}
							}
						} else {
							let response = { count: 0, results: [] };
							if (loadingUid === this.loadingUid) {
								this.loadResults(response);
								if (callback !== undefined) callback(this);
								if (this.onLoad !== undefined) {
									this.onLoad(this, response);
								}
								this.renderTallyExtra();
								this.table.trigger('smagrid:reloaded');
							}
						}
					},
					this
				),
				dataType: 'json'
			};

			if (this.acceptType) {
				ajaxOptions['headers'] = {
					Accept: this.acceptType,
				};
			}

			$.ajax(ajaxOptions);
		} else {
			this.loadResults(this.results);
			if (this.onLoad !== undefined) {
				this.onLoad(this, this.results);
			}
			this.table.trigger('smagrid:reloaded');
		}
	},

	getUrl() {
		return this.url;
	},

	refreshColumn(column, columnIndex) {
		return $.proxy((e) => {
			let i = 0;
			for (let row of this.data.results) {
				let cellVal = column.formatter.call(this, row[i], this, i);
				if (cellVal instanceof $) {
					this.body.find('tr').eq(i).find('td').eq(columnIndex).append(cellVal);
				} else {
					this.body.find('tr').eq(i).find('td').eq(columnIndex).html(cellVal);
				}
				i++;
			}
		}, this);
	},

	loadEachResult(data, folder_id) {
		let that = this;

		let columnIndex = 0;
		for (let column of that.visibleColumns) {
			if (column.reformatOn !== undefined) {
				that.table.on(column.reformatOn, $.proxy(this.refreshColumn(column, columnIndex + 1), this));
			}
			columnIndex++;
		}

		data.results.forEach((item, i) => {
			let row = $('<tr></tr>', { 'name': item.id, 'class': that.rowClass });

			if (that.showSelectorColumn === true) {
				if (!item.is_unselectable) {
					let selected = this.selectedIds.includes(item.id);
					let checkbox = $('<td></td>', {
						...(this.showSelectLabel ? { role: 'select' } : {}),
						...(!this.showSelectLabel ? { class: 'js-grid-row-select' } : {}),
						html: checkboxTemplate(
							{
								selected: selected,
								ariaLabel: item?.award?.name || ''
							},
						),
					});
					row.append(checkbox);

				} else {
					row.append($('<td></td>'));
				}
			}

			// Render each row's column value
			that.visibleColumns.forEach((col) => {
				let cellVal = that.buildCell(item, col, i);
				row.append(cellVal);
			});

			let speed = i * 50;

			if (speed > 400) {
				speed = 400;
			}

			row = row.css({ opacity: 0 }).animate({ opacity: 1 }, speed);

			if (folder_id) {
				row.addClass('sma-trigger-folder-item');
				row.data('folder_id', folder_id);
				row.hide();
			}

			that.body.append(row);

			if (that.folderGrid && item.folder) {
				row.data('folder', true);

				that.loadEachResult({ results: item.items }, item.id);
			}

			// Add all of the hidden nested tables
			// below the relevant rows
			that.expandableCols.forEach((col) => {
				let ident = col.name.toString() + '-' + i.toString();

				let nestedRow = nestedRowTempl({
					id: 'table-row-' + ident,
					nestedId: 'nested-table-' + ident,
				});

				that.body.append(nestedRow);

				let results = col.loadresults ? item[col.loadresults] : false;

				that.nestedTables['#table-row-' + ident] = new col.grid({
					item_id: item['id'],
					results: results,
					element: $('#nested-table-' + ident)
				});
			});

			// for nested content
			if (that.nestedContent && that.nestedContentTriggerClass) {
				let nestedRow = nestedRowTempl({
					id: `table-row-content-${i}`,
					nestedId: `nested-table-content-${i}`,
				});
				that.body.append(nestedRow);

				that.nestedContentRows[`#table-row-content-${i}`] = new that.nestedContent({
					parentGrid: that,
					item_id: item['id'],
					element: $(`#nested-table-content-${i}`, that.body),
				});
			}
		});
	},

	loadResults(data) {
		let that = this;

		if (this.folderGrid) {
			this.folders = [];
		}

		this.body.empty();
		this.data = data;
		this.total = data.count;

		this.nestedTables = {};
		this.nestedContentRows = {};

		if (data.count == 0) {
			let row = $('<tr></tr>', {
				colspan: '100%',
			}).append($('<td></td>', {
				colspan: '100%',
				html: emptyTempl({
					message: this.noDataMessage,
				}),
			}));

			that.body.append(row);
		}

		this.loadEachResult(data);

		this.renderFooter(data);

		this.table.show();
		this.footer.show();
		this.updateTally();

		this.loader.hide();
		this.loading = false;

		this.element.removeClass('sma-grid-loading');
	},

	loadPrev(e) {
		if (e) e.preventDefault();
		this.page--;
		if (!this.multiPageSelect) {
			this.clearSelections()
		}
		this.load();
	},

	loadNext(e) {
		if (e) e.preventDefault();
		this.page++;
		if (!this.multiPageSelect) {
			this.clearSelections()
		}
		this.load();
	},

	getRowById(id) {
		for (let row of this.body.find('tr')) {
			if ($(row).attr('name') == id) {
				return $(row);
			}
		}
		return null;
	},

	disableRow(row, id) {
		this.unselectRow(row, id);
		const td = this.showSelectLabel ? $(row).find('td[role="select"]') : $(row).find('td.js-grid-row-select');
		td.find('td[role="select"] input').prop('checked', false);

		td.find('td[role="select"] input').prop('disabled', true);
	},

	disableRowById(id) {
		var row = this.getRowById(id);

		if (row == null) return;

		this.disableRow(row, id);

		this.updateTally();
	},

	enableAll() {
		for (let row of this.body.find('tr')) {
			const td = this.showSelectLabel ? $(row).find('td[role="select"]') : $(row).find('td.js-grid-row-select');
			td.find('input').prop('disabled', false);
		}
	},

	enableRow(row, id) {
		const td = this.showSelectLabel ? $(row).find('td[role="select"]') : $(row).find('td.js-grid-row-select');
		td.find('input').prop('disabled', false);
	},

	enableRowById(id) {
		var row = this.getRowById(id);

		if (row == null) return;

		this.enableRow(row, id);

		this.updateTally();
	},

	selectRow(row, id) {
		row.addClass('sma-grid-row-selected');
		this.selectedIds.push(id);
		this.selectedRows.push(
			_.find(this.data.results, obj => (obj.id == id)),
		);
		if (this.showSelectorColumn) {
			let checkbox = $('<td></td>',
				{
					...(this.showSelectLabel ? { role: 'select' } : {}),
					...(!this.showSelectLabel ? { class: 'js-grid-row-select' } : {}),
					html: checkboxTemplate(
						{
							selected: true,
						},
					),
				}
			);

		}
	},

	selectRowById(id, fireEvent = true) {
		var row = this.getRowById(id);

		if (row == null) return;

		this.selectRow(row, id);
		const td = this.showSelectLabel ? $(row).find('td[role="select"]') : $(row).find('td.js-grid-row-select');
		td.find('input').prop('checked', true);

		if (fireEvent) {
			this.table.trigger('rowSelectionChanged', null, id, row);
		}

		this.updateTally();
	},

	unselectRowById(id, fireEvent = true) {
		var row = this.getRowById(id);

		if (row == null) return;

		this.unselectRow(row, id);
		const td = this.showSelectLabel ? $(row).find('td[role="select"]') : $(row).find('td.js-grid-row-select');
		td.find('input').prop('checked', false);

		if (fireEvent) {
			this.table.trigger('rowSelectionChanged', null, id, row);
		}

		this.updateTally();
	},

	unselectRow(row, id) {
		row.removeClass('sma-grid-row-selected');
		this.selectedIds = _.without(this.selectedIds, id);
		this.selectedRows = _.without(
			this.selectedRows,
			_.find(this.data.results, obj => (obj.id == id)),
		);
	},

	clearSelections() {
		this.table.find('.sma-js-select-all:first')
			.prop('checked', false)
			.prop('indeterminate', false);
		this.selectedIds = [];
		this.selectedRows = [];
		for (let row of this.body.find('tr')) {
			this.unselectRowById($(row).attr('name'), false);
		}
	},

	resetAndRender() {
		this.clearSelections();
		this.render();
	},

	selectAll(e) {
		e.preventDefault();
		let box = $(e.currentTarget);
		const selected_rows = this.findRows()
		const selectSelector = this.showSelectLabel ? 'td[role="select"]' : 'td.js-grid-row-select';
		const numChecked = selected_rows.find(`${selectSelector} input:checked`).length;
		const num = selected_rows.find(`${selectSelector} input`).length;
		const box_checked = numChecked !== num;
		// All rows that aren't folder rows or diabled
		let rows = this.body.find('tr').map(((i, row) => {
			if (!$(row).data('folder') && $(row).find(`${selectSelector} input:hidden`).length === 0 && !$(row).find(`${selectSelector} input`).prop('disabled')) {
				return row;
			}
		}));

		let inputs = box_checked ? rows.find(`${selectSelector} input:not(:checked)`) : rows.find(`${selectSelector} input:checked`);

		inputs.each((i, input) => {
			$(input).trigger('click');
		});
		setTimeout(() => { this.changeSelectAll() }, 0)
	},

	changedRowsPerPage(e) {
		const selectedValue = parseInt($(e.currentTarget).val(), 10);

		if (this.perPageAmounts.includes(selectedValue)) {
			this.perPage = selectedValue;
			this.page = 1;
			this.load();
		}
	},
	findRows() {
		const rows = this.body.find('tr').map(((i, row) => {
			let returnRow;
			if (!$(row).data('folder')) {
				returnRow = row;
			}
			return returnRow;
		}));
		return rows
	},
	changeSelectAll() {
		const rows = this.findRows();
		let all_indeterminate = false;
		let all_checked = false;
		if (this.multiPageSelect) {
			all_indeterminate = (
				typeof this.selectedIds.length !== 'undefined' &&
				this.selectedIds.length !== 0 &&
				this.selectedIds.length !== this.total
			);
			all_checked = this.total === this.selectedIds.length;
		}
		else {
			const selectSelector = this.showSelectLabel ? 'td[role="select"]' : 'td.js-grid-row-select';
			const numChecked = rows.find(`${selectSelector} input:checked`).length;
			const num = rows.find(`${selectSelector} input`).length;
			const not_selectable = rows.find('td label:hidden').length;
			all_indeterminate = typeof numChecked !== 'undefined' && numChecked !== 0 && numChecked !== num - not_selectable
			all_checked = numChecked === num - not_selectable
		}
		this.table.find('.sma-js-select-all:first')
			.prop('indeterminate', all_indeterminate)
			.prop('checked', all_checked);
	},
	rowSelectionChanged(e) {
		// Check if all checkboxes are selected
		e.preventDefault();
		const rows = this.findRows()



		const box = $(e.currentTarget);
		const row = box.parents('tr:first');
		let id = row.attr('name');
		if (this.intID) {
			id = parseInt(id, 10);
		}

		// Makes nearly nested tables work (org profile teams for example)
		if (!$.contains(this.body[0], box[0])) return;

		// Click on folder row
		if (row.data('folder')) {
			box.next().removeClass('mixed-checkbox').text('');

			let checked = true;

			if (box.is(':checked')) {
				checked = false;
			}

			this.getFolderSubRows(id).each((i, item) => {
				const selectSelector = this.showSelectLabel ? 'td[role="select"]' : 'td.js-grid-row-select';
				$(item).find(`${selectSelector} input`).prop('checked', checked).trigger('click');
			});
		} else { // Click on a normal row
			if (box.is(':checked')) {
				this.selectRow(row, id);
			} else {
				this.unselectRow(row, id);
			}

			const folderId = row.data('folder_id');
			// If the row is inside a folder
			if (folderId) {
				this.handleFolderCheckbox(folderId);
			}
		}

		this.table.trigger('rowSelectionChanged', e, id, row);
		this.updateTally();
		this.changeSelectAll();
	},

	handleFolderCheckbox(folderId) {
		const $folderRow = this.getFolderRow(folderId);
		const selectSelector = this.showSelectLabel ? 'td[role="select"]' : 'td.js-grid-row-select';
		const $folderInput = $folderRow.find(`${selectSelector} input`);

		const $folderSubRows = this.getFolderSubRows(folderId);
		const $selectedSubRows = $folderSubRows.filter('.sma-grid-row-selected');

		if (!$selectedSubRows.length) {
			$folderInput.prop('checked', false);
			$folderInput.next().removeClass('mixed-checkbox').text('');
		} else if ($folderSubRows.length > $selectedSubRows.length) {
			$folderInput.prop('checked', false);
			$folderInput.next().addClass('mixed-checkbox').text('-');
		} else {
			$folderInput.prop('checked', true);
			$folderInput.next().removeClass('mixed-checkbox').text('');
		}
	},

	setSortCache(col, dir) {
		localStorage.setItem(this.sortCacheKey, col);

		const dirCacheKey = `dir.${this.sortCacheKey}`;
		localStorage.setItem(dirCacheKey, dir);
	},

	cachedSort() {
		const sortColumn = localStorage.getItem(this.sortCacheKey);

		const dirCacheKey = `dir.${this.sortCacheKey}`;
		const sortDir = localStorage.getItem(dirCacheKey);

		this.orderedBy = sortColumn;
		this.orderDir = sortDir;
	},

	updateSortColumn(col, dir) {
		if (this.sortCacheKey !== '') {
			this.setSortCache(col, dir);
		}

		const column = this.table.find(`.grid-column-name[data-column="${col}"]`);
		column.siblings().removeClass('desc').removeClass('asc');

		column.removeClass('desc').removeClass('asc');
		if (dir) {
			column.addClass(dir);
		}
		if (col === '' || col === undefined) {
			/* no sorting, so no column should have asc and desc */
			this.table.find('.grid-column-name').removeClass('desc').removeClass('asc');
		}

		this.orderedBy = col;
		this.orderDir = dir;
	},

	orderingSelectionChanged(e) {
		e.preventDefault();
		const target = $(e.currentTarget);
		let orderedBy = target.attr('data-column');
		let { orderDir } = this;

		if (this.orderedBy !== orderedBy || orderDir === '') {
			orderDir = 'asc';
		} else if (orderDir === 'asc') {
			orderDir = 'desc';
		} else {
			orderDir = '';
			orderedBy = '';
		}

		this.updateSortColumn(orderedBy, orderDir);
		this.load();
	},

	search(e) {
		if (e) {
			e.preventDefault();
		}
		this.searchterm = this.searchBox.val();
		this.page = 1;
		this.clearSelections();
		this.load();
	},

	updateColumn(col) {
		return col;
	},

	defaultCellFormatter(item, col) {
		let val = item[col.id] || '';
		return (typeof val === 'string') ? _.escape(val) : val;
	},

	formatCell(item, col) {
		col = this.updateColumn(col);
	},

	formatCellValue(item, col, rowIndex) {
		let html = (typeof (col.formatter) !== 'undefined') ?
			col.formatter.call(this, item, this, rowIndex) :
			this.defaultCellFormatter(item, col);

		return html;
	},

	buildCell(item, col, i) {
		let value = this.formatCellValue(item, col, i);

		let cell = $('<td></td>', {
			role: col.id,
			class: col.class,
		}).append(value);

		// Add additional button to load nested tables
		if (this.isExpandable(col.id)) {
			cell.append($('<button></button>', {
				'class': 'btn btn-sm btn-icononly dropdown-toggle sma-js-nested-table',
				'data-target': '#table-row-' + col.id.toString() + '-' + i.toString(),
			}));
		}

		// Set nested content loader class and target info
		if (this.nestedContent && this.nestedContentTriggerClass) {
			let $item = cell.find(`.${this.nestedContentTriggerClass}`);

			$item.addClass('sma-js-nested-content');
			$item.data('target', `#table-row-content-${i.toString()}`);
		}

		return cell;
	},

	isExpandable(name) {
		for (let k in this.expandableCols) {
			if (this.expandableCols[k].name == name) {
				return true;
			}
		}
		return false;
	},

	expandNestedTable(e) {
		e.preventDefault();
		const curr = $(e.currentTarget);
		const row = curr.parent();

		$(curr.data('target')).toggle();
		row.toggleClass('sma-users-detail-row-expanded');

		// Don't call render when hiding
		if (row.hasClass('sma-users-detail-row-expanded')) {
			this.nestedTables[curr.data('target')].render();
		}
	},

	expandNestedContent(e) {
		e.preventDefault();
		const curr = $(e.currentTarget);
		const row = curr.closest('tr');

		$(curr.data('target')).toggle();
		row.toggleClass('sma-users-detail-row-expanded');

		// Don't call render when hiding
		if (row.hasClass('sma-users-detail-row-expanded')) {
			this.nestedContentRows[curr.data('target')].render(curr);
		}
	},

	getFolderSubRows(id) {
		return this.body.find('tr').filter(function () {
			return $(this).data('folder_id') === id;
		});
	},

	getFolderRow(id) {
		return this.body.find('tr').filter(function () {
			return ($(this).data('folder') === true) &&
				($(this).attr('name') === id.toString());
		});
	},

	expandFolderContent(e) {
		const curr = $(e.currentTarget);
		const row = curr.closest('tr');

		const id = parseInt(row.attr('name'));
		this.getFolderSubRows(id).fadeToggle();

		curr.find('.sma-js-triggers-folder-arrow').toggle();
	},

	// use this as a generic post for your actions.
	// It will pass the selected ids to your url and execute your callback
	postIds(options) {
		const postData = options.ids ? { ids: options.ids } : { ids: options.data.ids };

		new Confirm(
			options.title, options.message,
			() => {
				ajax.post({
					url: options.url,
					data: postData,
					callback: (result) => {
						if (options.callback) {
							options.callback(result);
						}
						this.clearSelections();
						this.load();
					},
				});
			},
			{},
		);
	},
});

const InnerGrid = Grid.extend({
	columns: [],
	isLoaded: false,

	initialize(config) {
		this.item_id = config.item_id;
		this.results = config.results;
		this.visibleColumns = this.columns;
		this.element = $(config.element[0]);
		this.setElement(config.element[0]);
	},

	renderHeaders() {
		let row = $('<tr></tr>');

		if (this.showSelectorColumn == true) {
			row.append(
				$('<th></th>', {
					role: 'select',
				}),
			);
		}

		this.columns.forEach((col, j) => {
			row.append(
				$('<th></th>', {
					text: col.name,
					'data-column': col.id,
				}),
			);
		});

		this.head.append(row);
	},

	renderFooter(data) {
		return;
	},

	render() {
		if (!this.isLoaded) {
			Grid.prototype.render.call(this);
		}
		this.isLoaded = true;
	},

	getURL() {
		return '';
	},

	load() {
		let that = this;
		this.body.empty();

		this.table.hide();
		this.footer.hide();

		this.loader.show();

		if (this.results === false) {
			$.get(this.getUrl(), this.getParams(), (response) => {
				that.loadResults(response);
			}, 'json');
		} else {
			this.loadResults(this.results);
		}
	},
});

const InnerContentGrid = Backbone.View.extend({
	initialize(config) {
		this.parentGrid = config.parentGrid;
		this.item_id = config.item_id;
		this.results = config.results;
		this.element = config.element[0];
		this.loader = new Loader(this.$el, 'md');
	},

	render($opener) {
		this.setElement(this.element);
		this.load();
		this.onOpen($opener);
	},

	getURL() {
		return '';
	},

	onOpen($opener) {
		return '';
	},

	close() {
		let expander = 'sma-users-detail-row-expanded';
		let $row = this.$el.closest('tr').hide();
		$row.prev(`.${expander}`).toggleClass(expander);
		this.onClose();
	},

	load() {
		this.loader.show();

		$.get(this.getUrl(), this.getParams(), (response) => {
			this.loader.hide();
			this.$el.html(this.formatter(response));
		}, 'json');
	},
});

module.exports = {
	Grid: Grid,
	InnerGrid: InnerGrid,
	InnerContentGrid: InnerContentGrid,
};
